<template>
  <div id="app" v-if="isReload" @click="test">
    <!-- <img src="@/assets/img/rtaLogo/home-page-r.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReload: true,
    };
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      );
    }
    //在页面刷新时讲vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  },

  methods: {
    //刷新不会出现空白页面
    reload() {
      this.isReload = false;

      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    test() {
      // localStorage.removeItem('token');
      // localStorage.removeItem('userInfo');
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  height: 100% !important;
  width: 100%;
}
body {
  margin: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue